import React from 'react'

import './Tooltip.scss'

interface TooltipProps {
  readonly title?: string
  readonly text?: string
  readonly textElement?: JSX.Element
  readonly position?: 'top' | 'bottom'
}

const Tooltip: React.FC<TooltipProps> = props => {
  const { title, text, textElement, position = 'top' } = props

  const shouldRenderTitle = !!title
  const textToRender = textElement || text
  const shouldRenderText = !!textToRender

  return (
    <div className={`Tooltip Tooltip--${position}`}>
      <div className="Tooltip__content">
        {shouldRenderTitle && (
          <div className="Tooltip__title">{title}</div>
        )}
        {shouldRenderText && (
          <div className="Tooltip__text">
            {textToRender}
          </div>
        )}
      </div>
      <div className="Tooltip__arrow-border" />
      <div className="Tooltip__arrow" />
    </div>
  )
}

export default Tooltip
